module.exports = __webpack_public_path__ + "docs/security-audit-291599.md";